<template>
  <vs-wrapper>
    <div
      v-for="(invGroup, position) in groupedInventory"
      :key="position"
      class="line-connector"
      :style="{
        '--count': invGroup.length - 1,
      }"
    >
      <location-row
        type="pickup"
        :location-id="invGroup[0].pickupLocationId"
        :location-name="invGroup[0].pickupLocationName"
      >
        <template #after>
          <vs-wrapper space="small">
            <v-row v-for="inv in formatInventories(invGroup)" :key="inv" dense>
              <v-col class="shrink">
                <v-icon small>mdi-cart</v-icon>
              </v-col>
              <v-col class="grow">
                <vs-text>{{ inv }}</vs-text>
              </v-col>
            </v-row>
          </vs-wrapper>
        </template>
      </location-row>
    </div>
    <div>
      <location-row type="destination" :location-name="destinationLocationName">
        <template #edit-button>
          <slot name="edit-button" />
        </template>
        <template #after>
          <slot name="destination-receipt" />
        </template>
      </location-row>
    </div>
  </vs-wrapper>
</template>

<script setup lang="ts">
import { groupBy } from 'lodash'
import { computed } from 'vue'
import PositionedInventory from '@/models/inventory'
import LocationRow from '@/components/jobs/LocationRow.vue'
import VsText from '@/components/vision/VsText.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'

const props = defineProps<{
  destinationLocationName: string
  inventory: PositionedInventory[]
}>()

const groupedInventory = computed(() => groupBy(props.inventory, 'position'))
const formatInventories = (invGroup) => {
  return invGroup.map(
    (inv: PositionedInventory) => `(Qty ${inv.quantity}) ${inv.inventorySubTypeName} · ${inv.name}`,
  )
}
</script>

<style scoped>
.line-connector {
  position: relative;
}

.line-connector::before {
  content: '';
  position: absolute;
  top: 40px;
  left: calc(var(--base-unit) / 1.33);
  transform: translateX(-50%);
  background-color: var(--color-grey--lighter);
  display: block;
  width: var(--space-smaller);
  height: calc(35px + var(--count) * var(--space-larger));
}

.add-text {
  font-family: var(--font-display), serif;
  font-weight: bold;
  color: var(--color-grey--light);
}
</style>
